import { useSelector } from "react-redux";
import { Card, CardBody, FormFeedback, Input } from "reactstrap";
import React, { useEffect } from 'react';
import Select from "react-select";
import { useFormik } from "formik";
import { optionQuoteContactCode, optionQuoteContacttitle } from '../../../common/data/sales';
import { getCompanyCountryData, getCompanyPincodeData, getCompanyStateData } from "../../../store/Settings/actions";
import { useDispatch } from "react-redux";
import { country_list, state_list } from "../../../common/data/settings";

const ConsigneeForm = ({ bookingFormik, proceedToNext, activeItem, isConsigneeCopyBillingAddress, onConsigneeCountryChange }) => {
    const { settings_companyCity_data, settings_companyState_data, settings_companyCountry_data, settings_companyPincode_data } = useSelector((state) => state?.settings);
    const dispatch = useDispatch();


    useEffect(() => {
        const setConsigneeData = () => {
            console.log(activeItem, "activeItem ConsigneeForm")
            if (settings_companyState_data && settings_companyState_data?.content?.length > 0 && activeItem === 'consigneedetails') {
                bookingFormik.setFieldValue("consigneeStateId", settings_companyState_data?.content[0]?.id || "", true);
                bookingFormik.setFieldTouched('consigneeStateId', true, true); // true triggers validation after touch
                bookingFormik.setFieldValue("consigneeState", settings_companyState_data?.content[0]?.stateName || "", true);
                bookingFormik.setFieldTouched('consigneeState', true, true); // true triggers validation after touch
            }
            if (settings_companyCountry_data && settings_companyCountry_data?.content?.length > 0 && activeItem === 'consigneedetails') {
                bookingFormik.setFieldValue("consigneeCountryId", settings_companyCountry_data?.content[0]?.id || "", true);
                bookingFormik.setFieldTouched('consigneeCountryId', true, true); // true triggers validation after touch
                bookingFormik.setFieldValue("consigneeCountry", settings_companyCountry_data?.content[0]?.countryName || "", true);
                bookingFormik.setFieldTouched('consigneeCountry', true, true); // true triggers validation after touch
                onConsigneeCountryChange(settings_companyCountry_data?.content[0]?.id || "");
            }
        };
        setConsigneeData();
    }, [settings_companyState_data, settings_companyCountry_data, activeItem]);

    return (
        <>
            <div className="customer_form_details">
                <Card>
                    <CardBody>
                        <form>
                            <div className="row">
                                <div className="col-12 col-md-6 mb-4">
                                    <div className="form-check form-switch" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            id="flexSwitchCheckDefault"
                                            disabled={bookingFormik?.values?.isShipperCopyBillingAddress === true}
                                            checked={bookingFormik?.values?.isConsigneeCopyBillingAddress || false}
                                            onClick={() => {
                                                const current = bookingFormik?.values?.isConsigneeCopyBillingAddress || false;
                                                bookingFormik.setFieldValue('isConsigneeCopyBillingAddress', !current);
                                                isConsigneeCopyBillingAddress(!current);
                                            }}
                                        />
                                        <label
                                            className="form-check-label mt-2"
                                            htmlFor="flexSwitchCheckDefault"
                                            style={{ marginBottom: 0 }}>
                                            Same As Billing Address
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">First Name</label>
                                        <Input
                                            type="text"
                                            name="consigneeFirstName"
                                            value={bookingFormik?.values?.consigneeFirstName}
                                            onChange={async (e) => {
                                                await bookingFormik.handleChange(e, true); // true triggers validation after set
                                                bookingFormik.setFieldTouched('consigneeFirstName', true, true); // true triggers
                                            }}
                                            onBlur={bookingFormik.handleBlur}
                                            invalid={bookingFormik.touched.consigneeFirstName && bookingFormik.errors.consigneeFirstName ? true : false}
                                            className="form-control"
                                            placeholder=""
                                        />
                                        <FormFeedback>{bookingFormik.errors.consigneeFirstName}</FormFeedback>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Last Name</label>
                                        <Input
                                            type="text"
                                            name="consigneeLastName"
                                            value={bookingFormik?.values?.consigneeLastName}
                                            onChange={bookingFormik.handleChange}
                                            onBlur={bookingFormik.handleBlur}
                                            invalid={bookingFormik.touched.consigneeLastName && bookingFormik.errors.consigneeLastName ? true : false}
                                            className="form-control"
                                            placeholder=""
                                        />
                                        <FormFeedback>{bookingFormik.errors.consigneeLastName}</FormFeedback>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Phone Number</label>
                                            <div className='row'>
                                                <div className='col-4 col-md-3'>
                                                    <Select
                                                        name='opCode'
                                                        value={optionQuoteContactCode ? optionQuoteContactCode.find((option) => option.value === bookingFormik?.values?.consigneeOpCode) : ""}
                                                        onChange={async (e) => {
                                                            await bookingFormik.setFieldValue(`consigneeOpCode`, e.value, true);
                                                            bookingFormik.setFieldTouched('consigneeOpCode', true, true); // true triggers validation after touch
                                                        }}
                                                        placeholder="+91"
                                                        options={optionQuoteContactCode}
                                                        classNamePrefix="select2-selection form-select"
                                                    />
                                                </div>
                                                <div className='col-8 col-md-9'>
                                                    <Input
                                                        type="number"
                                                        name="consigneePhoneNumber"
                                                        value={bookingFormik?.values?.consigneePhoneNumber}
                                                        onChange={async (e) => {
                                                            await bookingFormik.handleChange(e, true); // true triggers validation after set
                                                            bookingFormik.setFieldTouched('consigneePhoneNumber', true, true); // true triggers
                                                        }}
                                                        onBlur={bookingFormik.handleBlur}
                                                        invalid={bookingFormik.touched.consigneePhoneNumber && bookingFormik.errors.consigneePhoneNumber ? true : false}
                                                        className="form-control"
                                                        placeholder=""
                                                    />
                                                    <FormFeedback>{bookingFormik.errors.consigneePhoneNumber}</FormFeedback>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Email Id</label>
                                            <Input
                                                type="text"
                                                name="consigneeEmail"
                                                value={bookingFormik?.values?.consigneeEmail}
                                                onChange={bookingFormik.handleChange}
                                                onBlur={bookingFormik.handleBlur}
                                                className="form-control"
                                                placeholder=""
                                                invalid={bookingFormik.touched.consigneeEmail && bookingFormik.errors.consigneeEmail ? true : false}
                                            />
                                            <FormFeedback>{bookingFormik.errors.consigneeEmail}</FormFeedback>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col">
                                        <div className="mb-3">
                                            <label className="form-label">Company Name</label>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <Input
                                                        type="text"
                                                        name="consigneeCompanyName"
                                                        value={bookingFormik.values.consigneeCompanyName}
                                                        onChange={bookingFormik.handleChange}
                                                        onBlur={bookingFormik.handleBlur}
                                                        invalid={bookingFormik.touched.consigneeCompanyName && bookingFormik.errors.consigneeCompanyName ? true : false}
                                                        placeholder="Company Name"
                                                        className="form-control"
                                                    />
                                                    <FormFeedback>{bookingFormik.errors.consigneeCompanyName}</FormFeedback>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col">
                                        <div className="mb-3">
                                            <label className="form-label">Address</label>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <Input
                                                        type="text"
                                                        name="consigneeCompanyAddress"
                                                        value={bookingFormik?.values?.consigneeCompanyAddress}
                                                        onChange={bookingFormik.handleChange}
                                                        onBlur={bookingFormik.handleBlur}
                                                        invalid={bookingFormik.touched.consigneeCompanyAddress && bookingFormik.errors.consigneeCompanyAddress ? true : false}
                                                        placeholder="Company Address"
                                                        className="form-control"
                                                    />
                                                    <FormFeedback>{bookingFormik.errors.consigneeCompanyAddress}</FormFeedback>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">City<span className='required_star'>*</span></label>
                                        <Input
                                            type="text"
                                            name="consigneeCity"
                                            list="cityList"
                                            autoComplete="off"
                                            value={bookingFormik?.values?.consigneeCity || ""}
                                            onBlur={bookingFormik.handleBlur}
                                            invalid={(bookingFormik.touched.consigneeCity && bookingFormik.errors.consigneeCity) || (bookingFormik.touched?.consigneeCityId && bookingFormik.errors.consigneeCityId) ? true : false}
                                            onChange={async (e) => {
                                                await bookingFormik.handleChange(e, true);
                                                bookingFormik.setFieldTouched('consigneeCity', true, true); // true triggers validation after touch
                                                bookingFormik.setFieldValue('consigneeState', '');
                                                bookingFormik.setFieldValue('consigneeCountry', '');
                                                bookingFormik.setFieldValue('consigneeZipcode', '');
                                                const cityData = settings_companyCity_data?.content?.find((city) => city.cityName === e.target.value);
                                                if (cityData) {
                                                    bookingFormik.setFieldValue("consigneeCityId", cityData.id)
                                                    dispatch(getCompanyStateData({ cityId: cityData.id }));
                                                    dispatch(getCompanyCountryData({ cityId: cityData.id }));
                                                    dispatch(getCompanyPincodeData({ cityId: cityData.id }));
                                                }
                                            }}
                                            className="form-control"
                                            placeholder="Type to search city..."
                                        />
                                        <FormFeedback>{bookingFormik.errors.consigneeCity || bookingFormik.errors.consigneeCityId}</FormFeedback>
                                        <datalist id="cityList">
                                            {settings_companyCity_data &&
                                                settings_companyCity_data?.content?.map((item, i) => (
                                                    <option key={i} value={item.cityName} />
                                                ))}
                                        </datalist>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">State</label>
                                        <Input
                                            type="text"
                                            name="consigneeState"
                                            list="stateList"
                                            autoComplete="off"
                                            value={bookingFormik?.values?.consigneeState || ''}
                                            onChange={async(e) => {
                                                await bookingFormik.handleChange(e, true); // true triggers validation after set
                                                bookingFormik.setFieldTouched('consigneeState', true, true); // true triggers validation
                                            }}
                                            onBlur={bookingFormik.handleBlur}
                                            invalid={bookingFormik.touched.consigneeState && bookingFormik.errors.consigneeState ? true : false}
                                            className="form-control"
                                            placeholder="Type to search state..."
                                            readOnly={true}
                                        />
                                        <FormFeedback>{bookingFormik.errors.consigneeState}</FormFeedback>
                                        <datalist id="stateList">
                                            {state_list &&
                                                state_list.map((item, i) => <option key={i} value={item} />)}
                                        </datalist>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Country</label>
                                        <Input
                                            type="text"
                                            name="consigneeCountry"
                                            list="countryList"
                                            autoComplete="off"
                                            value={bookingFormik?.values?.consigneeCountry || ""}
                                            onChange={async (e) => {
                                                await bookingFormik.handleChange(e, true); // true triggers validation after set
                                                bookingFormik.setFieldTouched('consigneeCountry', true, true); // true triggers validation
                                            }}
                                            onBlur={bookingFormik.handleBlur}
                                            invalid={bookingFormik.touched.consigneeCountry && bookingFormik.errors.consigneeCountry ? true : false}
                                            className="form-control"
                                            placeholder="Type to search country..."
                                            readOnly={true}
                                        />
                                        <FormFeedback>{bookingFormik.errors.consigneeCountry}</FormFeedback>
                                        <datalist id="countryList">
                                            {country_list &&
                                                country_list.map((item, i) => (
                                                    <option key={i} value={item} />
                                                ))}
                                        </datalist>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Zipcode</label>
                                        <Input
                                            type="text"
                                            name="consigneeZipcode"
                                            list="zipcodeList"
                                            autoComplete="off"
                                            value={bookingFormik?.values?.consigneeZipcode || ""}
                                            onChange={bookingFormik.handleChange}
                                            onBlur={bookingFormik.handleBlur}
                                            invalid={bookingFormik.touched.consigneeZipcode && bookingFormik.errors.consigneeZipcode ? true : false}
                                            className="form-control"
                                            placeholder="Type to search zipcode..."
                                        />
                                        <FormFeedback>{bookingFormik.errors.consigneeZipcode}</FormFeedback>
                                        <datalist id="zipcodeList">
                                            {settings_companyPincode_data &&
                                                settings_companyPincode_data?.content?.map((item, i) => (
                                                    <option key={i} value={item.pin} />
                                                ))}
                                        </datalist>
                                    </div>
                                </div>
                            </div>



                            <div className="d-flex justify-content-end">
                                <button className="btn btn-primary" onClick={(e) => {
                                    e.preventDefault();
                                    proceedToNext("addon");
                                }}>Continue</button>
                            </div>
                        </form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}


export default ConsigneeForm;
